import { Action } from 'redux';

export interface SocketState {
  unreadCount: number | null;
  notFirst: boolean;
  socket: any;
  notifications: any;
}

export const SOCKET_CONNECTED = 'SOCKET_CONNECTED';
export const UNREAD_COUNT = 'UNREAD_COUNT';
export const NOTIFICATION = 'NOTIFICATION';

export interface SocketConnectedSuccessAction
  extends Action<typeof SOCKET_CONNECTED> {
  payload: any;
}

export interface UnreadCountSuccessAction extends Action<typeof UNREAD_COUNT> {
  payload: any;
}

export interface NotificationSuccessAction extends Action<typeof NOTIFICATION> {
  payload: any;
}

export type SocketActionType =
  | SocketConnectedSuccessAction
  | UnreadCountSuccessAction
  | NotificationSuccessAction;
